// The grab zone on the right edge of a resizable head cell (see
// GridColumnResizeHandle). The zone is wider than the line it shows, so the
// edge is easy to catch without a pixel hunt.
export const HANDLE_WIDTH = 8;

export const resizeHandleSx = {
    'position': 'absolute',
    'top': 0,
    'right': 0,
    'bottom': 0,
    'width': HANDLE_WIDTH,
    'zIndex': 1,
    'cursor': 'col-resize',
    'touchAction': 'none',
    'userSelect': 'none',
    '&::after': {
        content: '""',
        position: 'absolute',
        top: '20%',
        bottom: '20%',
        right: 0,
        width: 2,
        borderRadius: 1,
        backgroundColor: 'transparent',
        transition: 'background-color 100ms ease'
    },
    'th:hover > &::after': {
        backgroundColor: 'divider'
    },
    '&:hover::after, &:focus-visible::after, &[data-active]::after': {
        top: 0,
        bottom: 0,
        backgroundColor: 'primary.main'
    },
    '&:focus-visible': {
        outline: 'none'
    }
};

export const GUIDE_WIDTH = 2;

// The line down the table from the edge being dragged (portalled to the
// body, placed in viewport coordinates by the handle).
export const resizeGuideSx = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: GUIDE_WIDTH,
    height: 0,
    zIndex: (theme) => theme.zIndex.tooltip,
    pointerEvents: 'none',
    backgroundColor: 'primary.main',
    willChange: 'transform'
};
